import { render, staticRenderFns } from "./ModuleHeader.vue?vue&type=template&id=1e9dfb6e&scoped=true&"
import script from "./ModuleHeader.vue?vue&type=script&lang=js&"
export * from "./ModuleHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9dfb6e",
  null
  
)

export default component.exports